module.exports = __webpack_public_path__ + "04_hair_gold.a37946ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/04_hair_gold.png
// module id = K+mR
// module chunks = 0